<template>
  <div class="agreement">
    <h2 class="center">
      <strong>授权书</strong>
    </h2>
    <p>致：商盟商务服务有限公司</p>
    <br />
    <p
      class="sp_cl"
    >授权人授权贵司将授权人支付账户中的可用余额（冻结的余额除外）自动提现至授权人支付账户绑定的银行账户中。贵司有权从提现金额中直接扣除提现过程中产生的服务费（如有）。</p>
    <p class="sp_cl sp_underLine">
      <strong>授权人确认贵司只是被授权指令的执行方，贵司不对贵司根据本授权书所做的操作作任何承诺或保证。本授权书项下的账号资金划扣等操作导致的相关损失和责任，与贵司无关，贵司不对该等操作产生的损失和责任负责。因此产生的任何后果由授权人承担。</strong>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped lang="less">
.agreement {
  text-align: left;
  padding: 20px;
  .sp_cl {
    text-indent: 2em;
    margin-bottom: 8px;
  }
  .sp_rf {
    text-align: right;
  }
  .sp_underLine {
    text-decoration: underline;
  }
  .center {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
